export default {
  items: {
    team: {
      filename: 'devradar-Galactic Federation Technology Stack.toml',
      title: 'Galactic Federation Technology Stack',
      payload: {
        meta: {
          title: 'Galactic Federation Technology Stack',
          categories: ['Tools', 'Techniques', 'Platforms', 'Frameworks'],
          levels: ['Hold', 'Assess', 'Trial', 'Adopt'],
          name: 'Noone'
        },
        blips: [{
          category: 0,
          level: 3,
          title: 'GitLab CI'
        }, {
          category: 3,
          level: 3,
          title: 'Node.js'
        }, {
          category: 2,
          level: 3,
          title: 'Kubernetes'
        }, {
          category: 2,
          level: 3,
          title: 'Docker'
        }, {
          category: 1,
          level: 2,
          title: 'docs as code'
        }, {
          category: 3,
          level: 3,
          title: 'Python'
        }, {
          category: 1,
          level: 3,
          title: 'CI/CD'
        }, {
          category: 0,
          level: 1,
          title: 'Azure DevOps'
        }, {
          category: 3,
          level: 2,
          title: 'Vue.js'
        }, {
          category: 3,
          level: 2,
          title: 'Angular'
        }, {
          category: 0,
          level: 3,
          title: 'Jenkins'
        }, {
          category: 1,
          level: 2,
          title: 'Infrastructure as Code'
        }, {
          category: 0,
          level: 2,
          title: 'Terraform'
        }, {
          category: 0,
          level: 3,
          title: 'Ansible'
        }, {
          category: 1,
          level: 2,
          title: 'Web Design'
        }, {
          category: 3,
          level: 3,
          title: 'C++'
        }, {
          category: 2,
          level: 3,
          title: 'Azure IaaS'
        }, {
          category: 2,
          level: 2,
          title: 'Azure P/SaaS'
        }, {
          category: 2,
          level: 1,
          title: 'GitHub'
        }, {
          category: 2,
          level: 3,
          title: 'BitBucket'
        }]
      }
    },
    devs: [{
      filename: 'devradar-Mortys personal radar.toml',
      title: 'Mortys personal~ radar',
      payload: {
        meta: {
          title: 'Mortys personal~ radar',
          categories: ['Tools', 'Techniques', 'Platforms', 'Frameworks'],
          levels: ['Novice', 'Intermediate', 'Advanced', 'Veteran'],
          name: 'Noone'
        },
        blips: [{
          category: 0,
          level: 3,
          title: 'GitLab CI'
        }, {
          category: 3,
          level: 0,
          title: 'Go'
        }, {
          category: 2,
          level: 0,
          title: 'Kubernetes'
        }, {
          category: 2,
          level: 2,
          title: 'Docker'
        }, {
          category: 1,
          level: 2,
          title: 'docs as code'
        }, {
          category: 0,
          level: 3,
          title: 'Matlab'
        }, {
          category: 3,
          level: 3,
          title: 'OpenCV'
        }, {
          category: 3,
          level: 1,
          title: 'Python'
        }, {
          category: 3,
          level: 2,
          title: 'Javascript'
        }, {
          category: 3,
          level: 3,
          title: 'CSS'
        }, {
          category: 1,
          level: 3,
          title: 'Design'
        }, {
          category: 1,
          level: 2,
          title: 'Deep Learning'
        }, {
          category: 2,
          level: 2,
          title: 'Blockchain'
        }, {
          category: 0,
          level: 0,
          title: 'Ansible'
        }, {
          category: 0,
          level: 1,
          title: 'Azure RM'
        }, {
          category: 0,
          level: 2,
          title: 'Chef'
        }]
      }
    }, {
      filename: 'devradar-Tammys devradar.toml',
      title: 'Tammy\'s devradar',
      payload: {
        meta: {
          title: 'Tammy\'s devradar',
          categories: ['Tools', 'Techniques', 'Platforms', 'Frameworks'],
          levels: ['Novice', 'Intermediate', 'Advanced', 'Veteran'],
          name: 'Noone'
        },
        blips: [{
          category: 3,
          level: 2,
          title: 'Javascript'
        }, {
          category: 3,
          level: 3,
          title: 'CSS'
        }, {
          category: 1,
          level: 3,
          title: 'Design'
        }, {
          category: 2,
          level: 3,
          title: 'GitHub'
        }, {
          category: 0,
          level: 3,
          title: 'Circle CI'
        }, {
          category: 0,
          level: 1,
          title: 'Drone CI'
        }, {
          category: 0,
          level: 2,
          title: 'Netlify'
        }, {
          category: 2,
          level: 3,
          title: 'zeit.now'
        }, {
          category: 1,
          level: 3,
          title: 'Web Development'
        }, {
          category: 3,
          level: 3,
          title: 'HTML'
        }, {
          category: 3,
          level: 2,
          title: 'Material Design'
        }, {
          category: 3,
          level: 3,
          title: 'Angular'
        }, {
          category: 3,
          level: 1,
          title: 'React'
        }, {
          category: 3,
          level: 0,
          title: 'Vue.js'
        }, {
          category: 2,
          level: 2,
          title: 'Heroku'
        }]
      }
    }, {
      filename: 'devradar-Andreas technical skills.toml',
      title: 'Andreas\' technical skills',
      payload: {
        meta: {
          title: 'Andreas\' technical skills',
          categories: ['Tools', 'Techniques', 'Platforms', 'Frameworks'],
          levels: ['Novice', 'Intermediate', 'Advanced', 'Veteran']
        },
        blips: [{
          category: 0,
          level: 2,
          title: 'Terraform'
        }, {
          category: 3,
          level: 1,
          title: 'Vue'
        }, {
          category: 1,
          level: 1,
          title: 'Infrastructure as Code'
        }, {
          category: 1,
          level: 2,
          title: 'CI/CD'
        }, {
          category: 0,
          level: 3,
          title: 'PlantUML'
        }, {
          category: 3,
          level: 0,
          title: 'ROS'
        }, {
          category: 1,
          level: 2,
          title: 'Test Driven Development'
        }, {
          category: 0,
          level: 2,
          title: 'Docker'
        }, {
          category: 3,
          level: 1,
          title: 'bash'
        }, {
          category: 0,
          level: 1,
          title: 'Matlab'
        }, {
          category: 3,
          level: 0,
          title: 'c++'
        }, {
          category: 0,
          level: 2,
          title: 'VS Code'
        }, {
          category: 1,
          level: 2,
          title: 'Software Architecture'
        }, {
          category: 2,
          level: 2,
          title: 'Cloudfoundry'
        }, {
          category: 2,
          level: 0,
          title: 'Kubernetes'
        }, {
          category: 3,
          level: 3,
          title: 'Node.JS'
        }, {
          category: 2,
          level: 1,
          title: 'Google Firebase'
        }, {
          category: 1,
          level: 0,
          title: 'Deeplearning'
        }, {
          category: 3,
          level: 2,
          title: 'Python'
        }, {
          category: 0,
          level: 1,
          title: 'Jupyter'
        }, {
          category: 2,
          level: 1,
          title: 'Arduino'
        }, {
          category: 2,
          level: 2,
          title: 'Azure Functions'
        }, {
          category: 2,
          level: 0,
          title: 'Ethereum'
        }, {
          category: 0,
          level: 0,
          title: 'asciidoc'
        }, {
          category: 1,
          level: 1,
          title: 'Data Analytics'
        }, {
          category: 0,
          level: 1,
          title: 'Hugo'
        }, {
          category: 0,
          level: 0,
          title: 'Affinity Designer'
        }, {
          category: 3,
          level: 1,
          title: 'go'
        }, {
          category: 2,
          level: 2,
          title: 'GitHub'
        }, {
          category: 2,
          level: 2,
          title: 'Azure'
        }, {
          category: 1,
          level: 2,
          title: 'Web Design'
        }, {
          category: 0,
          level: 0,
          title: 'OpenCV'
        }, {
          category: 1,
          level: 2,
          title: 'Static Site Generators'
        }, {
          category: 1,
          level: 2,
          title: 'Docs as Code'
        }, {
          category: 1,
          level: 3,
          title: 'DevOps'
        }]
      }
    }]
  },
  settings: {
    categories: [],
    levels: [],
    blips: [{
      category: 1,
      level: 3,
      title: 'Design'
    }, {
      category: 3,
      level: 2,
      title: 'Javascript'
    }, {
      category: 3,
      level: 3,
      title: 'Angular'
    }, {
      category: 1,
      level: 2,
      title: 'CI/CD'
    }, {
      category: 2,
      level: 0,
      title: 'Kubernetes'
    }, {
      category: 1,
      level: 2,
      title: 'Infrastructure as Code'
    }, {
      category: 2,
      level: 3,
      title: 'Azure IaaS'
    }, {
      category: 3,
      level: 2,
      title: 'Vue.js'
    }, {
      category: 3,
      level: 3,
      title: 'Python'
    }]
  }
}
